<template>
    <div class="flex xs:flex-col border-t border-b border-t-white border-b-white ">
        <div class="p-3 w-full text-center  flex flex-col items-center border-r-yellow-400">
            <div class="border border-white rounded-full w-10 h-10 flex mb-2 icon-color justify-center items-center">
                <Icon id="pencil" source="images/papsi_phone.svg" :width="24" />
            </div>
           <span class="text-xl font-bold mb-1">Customer Support</span>
            <div>
                Smart: 0998-588-1969
            </div>
            <div>
                Globe: 0915-096-6361
            </div>
            <div>
                customer@pafcpic365.com
            </div>
        </div>
        <div class="p-3 w-full text-center flex flex-col items-center ">
            <div class="border border-white rounded-full w-10 h-10 flex mb-2 icon-color justify-center items-center">
                <Icon id="pencil" source="images/papsi_social_media.svg" :width="24" />
            </div>
            <div class="w-full mb-1">
                <span class="text-xl  font-bold">Social Media</span>
            </div>
            <div>
                <div class="flex icon-text">
                    <Icon source="images/Facebook_f_logo.png" class="pr-1" :width="20" />
                    <div>
                        <a
                        href="https://www.facebook.com/pafcpic"
                        target="_blank"
                        rel="noreferrer"
                        v-text="lang('facebook.text')"
                        />
                    </div>
                </div>
            </div>
            <div>
                <div class="flex icon-text">
                <Icon source="images/Instagram_logo.png" class="pr-1" :width="20" /> 
                <div>
                        <a
                        href="https://www.instagram.com/pafcpicofficial/ "
                        target="_blank"
                        rel="noreferrer"
                        v-text="lang('instagram.text')"
                        />
                    </div>
                
                </div>
            </div> 
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Icon from "./../../components/controls/Icon.vue";
import mixin from "./../../mixin";

export default defineComponent({
    components: {
        Icon,
    },
    mixins:[
       mixin,
    ],
})
</script>
<style>
.icon-text {
    inline-size: fit-content;
}
.icon-color {
    background: #019f00;
}
</style>